// frontend/src/components/RedirectIndexHtml.js
//
// GCS's static-website config 301-redirects a directory-style path like
// `/terms` to `/terms/index.html` (NOT `/terms/`) for every prerendered route
// object. React Router has no route matching `*/index.html`, so the page would
// render blank.
//
// A HARD LOAD of such a URL is normalised before React mounts
// (`normalizeIndexHtmlLocation` in src/index.js, backlog #465), so on that path
// this component is a no-op. It stays as the belt for an IN-APP navigation to
// an `/index.html` path (a stray link or navigate() call), rewriting it to the
// clean `*/` form (client-side, replace) so the correct route renders. The rule
// itself lives in utils/indexHtmlUrl.js - one definition, no second regex.

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isIndexHtmlPath, stripIndexHtml } from "../utils/indexHtmlUrl";

function RedirectIndexHtml() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isIndexHtmlPath(pathname)) {
      // "/terms/index.html" -> "/terms/"  (keeps trailing slash; React Router
      // matches "/terms/" to a path="/terms" route). "/index.html" -> "/".
      // Never throws out of the effect: a history API that refuses the
      // address (a SecurityError in a sandboxed frame, say) must not take the
      // app down over a cosmetic - the visitor simply stays where they are.
      try {
        navigate(`${stripIndexHtml(pathname)}${search}${hash}`, { replace: true });
      } catch (e) {
        /* left on the unmatched address; nothing else depends on this */
      }
    }
  }, [pathname, search, hash, navigate]);

  return null;
}

export default RedirectIndexHtml;
